"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Point = void 0;
const Rotation_1 = require("./Rotation");
class Point {
    static fromPoint(p) {
        return new Point(p.x, p.y);
    }
    constructor(x, y) {
        this.x = typeof x === 'string' ? parseFloat(x) : x;
        this.y = typeof y === 'string' ? parseFloat(y) : y;
    }
    rotate(rot) {
        let p = Point.fromPoint(this);
        if (rot === Rotation_1.Rotation.R0) {
            return p;
        }
        p = new Point(p.y, -p.x);
        if (rot === Rotation_1.Rotation.R270) {
            return p;
        }
        p = new Point(p.y, -p.x);
        if (rot === Rotation_1.Rotation.R180) {
            return p;
        }
        p = new Point(p.y, -p.x);
        return p;
    }
    add(p) {
        this.x += p.x;
        this.y += p.y;
    }
    toXYPosition() {
        return [this.x, this.y];
    }
}
exports.Point = Point;
//# sourceMappingURL=Point.js.map